import { FeatureFlagCollection } from '../interfaces/feature-flag.interface';

export const E2eFeatureFlagMock: Partial<Record<FeatureFlagCollection, boolean>> = Object.freeze({
  [FeatureFlagCollection.userFlows]: true,
  [FeatureFlagCollection.userFlowsGuided]: false,
  [FeatureFlagCollection.tenantRiskScore]: true,
  [FeatureFlagCollection.wsRiskScore]: true,
  [FeatureFlagCollection.dpRiskScore]: true,
  [FeatureFlagCollection.hideRiskManagementStatus]: false,
  [FeatureFlagCollection.govDashWebsiteAppsNewSection]: true,
  [FeatureFlagCollection.riskChartFrequency]: true,
  [FeatureFlagCollection.scimFunctionality]: true,
  [FeatureFlagCollection.scimGroupsSupport]: false,
  [FeatureFlagCollection.scansListRedesign]: true,
  [FeatureFlagCollection.scansRevampInPopup]: true,
  [FeatureFlagCollection.requestManualEvaluation]: true,
  [FeatureFlagCollection.filteringUsers]: true,
  [FeatureFlagCollection.removedStepper]: true,
  [FeatureFlagCollection.pushManualRequestAudit]: true,
  [FeatureFlagCollection.scanBanner]: true,
  [FeatureFlagCollection.manualEvaluationConformanceTab]: true,
  [FeatureFlagCollection.updateTaskSlideout]: true,
  [FeatureFlagCollection.navSupportPortalUx]: true,
  [FeatureFlagCollection.bulkWsAndDpsCreationWithCustomMonitoringSettings]: true,
  [FeatureFlagCollection.platformWidgetMgmt]: true,
  [FeatureFlagCollection.platformWidgetLSTBtns]: true,
  [FeatureFlagCollection.organizationPortfolio]: true,
  [FeatureFlagCollection.programPortfolioAssets]: false,
  [FeatureFlagCollection.userFlowsQ42023Revamp]: true,
  [FeatureFlagCollection.monitoringHistoricalReport]: true,
  [FeatureFlagCollection.evaluationsSummarization]: true,
  [FeatureFlagCollection.requestValidationTesting]: true,
  [FeatureFlagCollection.automaticTaskValidation]: false,
  [FeatureFlagCollection.commonFindings]: true,
  [FeatureFlagCollection.viewIssueTrackingConnectionStatus]: true,
  [FeatureFlagCollection.digitalAssetFindings]: true,
  [FeatureFlagCollection.artificialIntelligenceOptin]: true,
  [FeatureFlagCollection.asanaProjectsPagination]: false,
  [FeatureFlagCollection.newAutomatedEngine]: true,
  [FeatureFlagCollection.scanningAgent]: true,
  [FeatureFlagCollection.scanningAgentDebugMode]: true,
  [FeatureFlagCollection.artInScansAndMonitoring]: true,
  [FeatureFlagCollection.scanDebugging]: true,
  [FeatureFlagCollection.digitalPropertyTagging]: true,
  [FeatureFlagCollection.enableLevelCI]: false,
  [FeatureFlagCollection.auditOnlyPackage]: true,
  [FeatureFlagCollection.generateCommonFindingsForTenant]: true,
  [FeatureFlagCollection.editManualEvaluationStandards]: true,
  [FeatureFlagCollection.selfManageOrgHierarchy]: true,
  [FeatureFlagCollection.atlasUserManagement]: true,
  [FeatureFlagCollection.mobileTestingUseSauceLabs]: true,
  [FeatureFlagCollection.manageIssueTrackingConnectionInProjects]: true,
  [FeatureFlagCollection.mobileAllowMultipleApps]: false,
  [FeatureFlagCollection.showCommonFindingsSettingsModal]: true,
  [FeatureFlagCollection.cuetEvaluations]: false,
  [FeatureFlagCollection.addWaitTimeAutoScan]: true,
  [FeatureFlagCollection.laPdfValidationService]: true,
  [FeatureFlagCollection.laPdfAutoRemediation]: true,
  [FeatureFlagCollection.bulkAutoRemediatePdf]: true,
  [FeatureFlagCollection.manualEvaExportNewFields]: false,
  [FeatureFlagCollection.bulkDpWithCustomMonitoringSettings]: true,
  [FeatureFlagCollection.showStandardSelectPrompt]: true,
  [FeatureFlagCollection.removeAddDAButton]: false,
  [FeatureFlagCollection.digitalAssetsPrivacySetting]: true,
  [FeatureFlagCollection.scoreDesignSystem]: true,
  [FeatureFlagCollection.editPagesAndComponentsInMECreationFlow]: true,
  [FeatureFlagCollection.aiChat]: true,
  [FeatureFlagCollection.aiChatAddContext]: true,
  [FeatureFlagCollection.aiChatStreaming]: true,
  [FeatureFlagCollection.evaluationCopy]: true,
  [FeatureFlagCollection.createAutoVpat]: true,
  [FeatureFlagCollection.autoVpatTemplateDifferentiation]: true,
  [FeatureFlagCollection.recentScansTab]: false,
  [FeatureFlagCollection.daFindingsMobileEnabled]: true,
  [FeatureFlagCollection.customReportsPage]: true,
  [FeatureFlagCollection.reportingAgentExport]: true,
  [FeatureFlagCollection.verticalNavigation]: true,
  [FeatureFlagCollection.globalOrgSettings]: true,
  [FeatureFlagCollection.customReportsTimeframePicker]: true,
  [FeatureFlagCollection.reportingAgentShareReport]: true,
  [FeatureFlagCollection.removeToReviewFromClientView]: true,
  [FeatureFlagCollection.dsTable]: true,
  [FeatureFlagCollection.dsTablePages]: true,
  [FeatureFlagCollection.dsTableDesignReviewFindingsByScreen]: true,
  [FeatureFlagCollection.dsTableNotificationsList]: true,
  [FeatureFlagCollection.dsTableDesignReviewFindingsByCategory]: true,
  [FeatureFlagCollection.dsTableEvaluationRules]: true,
  [FeatureFlagCollection.dsTableAdminGlobalUsers]: true,
  [FeatureFlagCollection.dsTableAdminInternalUsers]: true,
  [FeatureFlagCollection.dsTableMonitoringPages]: true,
  [FeatureFlagCollection.dsTableRemainingFindings]: false,
  [FeatureFlagCollection.dsTableAdminGroups]: true,
  [FeatureFlagCollection.dsDatepicker]: false,
  [FeatureFlagCollection.restoreReport]: true,
  [FeatureFlagCollection.changeHowManualEvalsAreManagedByClients]: true,
  [FeatureFlagCollection.aIPoweredManualEvaluations]: true,
  [FeatureFlagCollection.artMetricsSynchronization]: false,
  [FeatureFlagCollection.scheduleReport]: true,
  [FeatureFlagCollection.manualEvaluationsSwa]: true,
  [FeatureFlagCollection.githubIssues]: true,
  [FeatureFlagCollection.githubIssuesBidirectional]: true,
  [FeatureFlagCollection.githubLinkExistingIssues]: true,
  [FeatureFlagCollection.githubCustomFields]: true,
  [FeatureFlagCollection.githubBulkPushOptions]: true,
  [FeatureFlagCollection.gitlabIntegration]: true,
  [FeatureFlagCollection.defaultScanTimeout]: true,
  [FeatureFlagCollection.flawMatchingMobile]: true,
  [FeatureFlagCollection.consolidateSettings]: false,
  [FeatureFlagCollection.aiChatCombinedChatPanel]: true,
  [FeatureFlagCollection.aiChatRenameChatSession]: true,
  [FeatureFlagCollection.scanLevelMetadata]: true,
  [FeatureFlagCollection.findingsTaskLinkedComments]: false,
  [FeatureFlagCollection.separatedBacklogReopenedStatus]: false,
  [FeatureFlagCollection.amplitudeGAndSSDK]: false,
  [FeatureFlagCollection.allowEditTaskFindingsComments]: false,
  [FeatureFlagCollection.apiTasks]: true,
  [FeatureFlagCollection.monitoringDocumentDiscovery]: true,
});
